/**
 * 当前订单查询所用的供应商 spiId。
 *
 * 不使用 URL query 传递，避免 spiId 暴露在地址栏里（也避免用户手改）。
 * 优先级：内存变量（本次会话内页面间传递） -> localStorage.gysCode（App.vue 写入，刷新后兜底）
 */

const STORE_KEY = "gysCode";

// 模块级单例：SPA 内路由跳转时传递，刷新页面后失效（此时回落到 localStorage）
let currentSpiId = "";

/**
 * 设置当前 spiId（同时写入 localStorage，保证刷新后仍可用）
 * @param {string} spiId
 */
export function setSpiId(spiId) {
  if (!spiId) return;
  currentSpiId = spiId;
  try {
    localStorage.setItem(STORE_KEY, spiId);
  } catch (e) {
    // localStorage 不可用（隐私模式等）时忽略，内存变量仍然有效
  }
}

/**
 * 获取当前 spiId
 * @returns {string}
 */
export function getSpiId() {
  if (currentSpiId) return currentSpiId;
  try {
    return localStorage.getItem(STORE_KEY) || "";
  } catch (e) {
    return "";
  }
}
